import classnames from 'classnames';
import React from 'react';
import css from './items-block-wrapper.scss';
const ItemsBlockWrapper = ({
  children,
  withMarginBottom = false,
  withShadow = false,
  withMarginTop = false,
  withBorder = false,
  isLastItem = false,
  isPlainCard = true,
  itemWrapperClassName
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(css.basic, itemWrapperClassName, {
      [css.withMarginBottom]: withMarginBottom,
      [css.withShadow]: withShadow,
      [css.withMarginTop]: withMarginTop,
      [css.withBorder]: withBorder,
      [css.isLastItem]: isLastItem,
      [css.isPlainCard]: isPlainCard
    })
  }, children);
};
export default ItemsBlockWrapper;